import * as React from 'react';
import { useForm } from "react-hook-form";
import type { SubmitHandler } from "react-hook-form";

import Button from '../Button/Button';
import SubmitButton from '../SubmitButton/SubmitButton';

import type { Income } from '../../types/Income';

type Input = {
    name: string;
    amount: string;
    repeats: boolean;
    date: string;
};

type IncomeRowProps = {
    income: Income, 
    index: number, 
    remove: (index: number) => void
};

function IncomeRow({income, index, remove}: IncomeRowProps) {
    const [view, setView] = React.useState<boolean>(false);
    const [edit, setEdit] = React.useState<boolean>(false);

    const {
        register,
        handleSubmit,
    } = useForm<Input>();

    const onSubmit: SubmitHandler<Input> = (data: Input) => {
        income.name = data.name;
        income.amount = parseFloat(data.amount);
        income.when.repeats = data.repeats;
        setEdit(false);
    }

    return (
        <div>
            <p>{income.name}</p>
            <Button callback={() => { setView(true) }}>View</Button>
            <Button callback={() => { setEdit(true) }}>Edit</Button>
            <Button callback={() => { remove(index) }}>Delete</Button>
            {view && (
                <div>
                    <p><span>Name:</span> <span>{income.name}</span></p>
                    <p><span>Amount:</span> <span>{income.amount}</span></p>
                    <Button callback={() => { setView(false) }}>Close</Button>
                </div>
            )}
            {edit && (
                <div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <label htmlFor="name">Name</label>
                        <input id="name" defaultValue={income.name} {...register("name")} />

                        <label htmlFor="name">Amount</label>
                        <input id="amount" type="number" min={0} step={0.01} defaultValue={income.amount} {...register("amount")} />

                        <label htmlFor="repeats">Repeats</label>
                        <input id="repeats" type="checkbox" {...register("repeats")} />

                        {/* <label htmlFor="date">Date:</label>
                        <input id="date" type="date" defaultValue={income.when.date} {...register("date")}></input> */}
                        <Button callback={() => { setEdit(false) }}>Cancel</Button>
                        <SubmitButton>Update</SubmitButton>
                    </form>
                </div>
            )}
        </div>
    );
}


export default IncomeRow;
